import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFnbDashboardData } from "./dashboard.thunk";

const init_state = {
  productsData: {
    stats: {},
    data: [],
    totals: 0,
  },
  loading: false,
  error: null,
};

export const fetchFnbProducts = createAsyncThunk(
  "fnb/fetchProducts",
  getFnbDashboardData
);

const fnbProductsSlice = createSlice({
  name: "fnb products",
  initialState: init_state,
  extraReducers: (builder) => {
    builder
      .addCase(fetchFnbProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFnbProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.productsData = action.payload;
      })
      .addCase(fetchFnbProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default fnbProductsSlice.reducer;
